<template>
  <div class="ov-card">
    <div class="ov-card__head">
      <div class="ov-card__title">Activités</div>
    </div>
    <div class="ov-card__body">
      <div class="ov-stat">
        <span class="ov-stat__label">Compte créé le</span>
        <span class="ov-stat__value">{{ account && account.createdAt ? account.createdAt : '—' }}</span>
      </div>
      <div class="ov-stat">
        <span class="ov-stat__label">Dernière connexion</span>
        <span class="ov-stat__value">{{ account && account.lastConnectionDate ? account.lastConnectionDate : '—' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserActivities.vue",
  props: {
    account: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/admin/ui";
</style>
